/* eslint-disable no-nested-ternary */
import React from 'react';
import { Flex, Skeleton, Box, Icon } from '@chakra-ui/core';
import { MdDomain } from 'react-icons/md';

interface LogoPreviewProps {
  isLoading: boolean;
  currentLogoUrl?: string;
  title: string;
  isDeleting: boolean;
  testId: string;
}

export const LogoPreview: React.FC<LogoPreviewProps> = React.memo(({ isLoading, currentLogoUrl, title, isDeleting, testId }) => (
  <Flex align="center" justify="center" bg="gray.50" borderRadius="md" width="240px" height="200px" flexShrink={0}>
    {isLoading ? (
      <Skeleton width="100%" height="100%" borderRadius="md" data-testid={testId} />
    ) : currentLogoUrl ? (
      <Box
        as="img"
        src={currentLogoUrl}
        alt={`${title} preview`}
        maxWidth="90%"
        maxHeight="90%"
        objectFit="contain"
        opacity={isDeleting ? 0.5 : 1}
        transition="opacity 0.15s ease"
      />
    ) : (
      <Icon as={MdDomain} boxSize="48px" color="gray.400" />
    )}
  </Flex>
));
LogoPreview.displayName = 'LogoPreview';
